// RUTA: src/lib/cardioEquipment.ts
//
// Lista de aparatos de cardio que el cliente puede seleccionar al
// registrar una sesión. Mantenerlo como dropdown con escape hatch
// "otro" da data limpia para métricas (kcal por aparato) sin bloquear
// al cliente que use algo no listado.

export const CARDIO_EQUIPMENT = [
  { id: 'caminadora', label: 'Caminadora', emoji: '🏃' },
  { id: 'bici',       label: 'Bicicleta',  emoji: '🚴' },
  { id: 'eliptica',   label: 'Elíptica',   emoji: '🤸' },
  { id: 'escaladora', label: 'Escaladora', emoji: '🪜' },
  { id: 'remo',       label: 'Remo',        emoji: '🚣' },
  { id: 'spinning',   label: 'Spinning',    emoji: '🚲' },
  { id: 'aire_libre', label: 'Aire libre',  emoji: '🌳' },
  { id: 'otro',       label: 'Otro',        emoji: '⚙️' },
] as const;

export type CardioEquipmentId = typeof CARDIO_EQUIPMENT[number]['id'];

export function getEquipmentLabel(id: string | null | undefined): string {
  if (!id) return '';
  const found = CARDIO_EQUIPMENT.find(e => e.id === id);
  return found ? `${found.emoji} ${found.label}` : id;
}
